import React, { Component, useRef } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardTitle,
  Col,
  Media,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { map } from "lodash";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class Reviews extends Component {
    constructor(props) {
        super(props);
        this.state = { curMessage: [] };
       
      }
    

      render() {
        const { reviews } = this.props;
        console.log(this.props.reviews)
        const { Lab } = this.props;
    
        return (
          <Card
            className="d-flex flex-column "
            style={{
              maxHeight: 600,
              overflowY: "auto",
              overflowX: "hidden",
              zIndex: 999,
            }}
          >
            
            {/* // {map(this.props.Q_and_As, (comment, index) => ( */}
            {/* {alert(Questions.length)} */}
            {Reviews.length ? (
              map(reviews, (review, index) => {
                return (
                  <Media className="mx-4 my-2" key={index}>
                    <div className="me-3">
                      {/* {Question.userImg ? (
                      <img
                        className="media-object rounded-circle avatar-xs"
                        alt=""
                        src={images[comment.userImg]}
                      />
                    ) : ( */}
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-16">
                          {review.name.charAt(0)}
                        </span>
                      </div>
                      {/* )} */}
                    </div>
                    <Media body>
                      <h5 className="font-size-13 mb-1">{review.name}</h5>
                      <p className="text-muted mb-1">{review.Review}</p>
    
                      {review.Reply ? (
                        <Media className="mt-1">
                          <div className="avatar-xs me-3">
                            
                              <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-16">
                                {Lab.name.charAt(0)}
                              </span>
                        
                          </div>
                          <Media body>
                            <h5 className="font-size-13 mb-1">{Lab.name}</h5>
                            <p className="text-muted mb-1">{review.Reply}</p>
                          </Media>
                        </Media>
                      ) : (
                        <div></div>
                      )}
                    </Media>
                  </Media>
                );
              })
            ) : (
              <div className="text-center align-self-center m-auto">
                <h3 className=" mb-1">No Reviews Found </h3>
                <h5 className="font-size-11 mb-1 text-secondary">
                  This service has no reviews yet
                </h5>
              </div>
            )}
          </Card>
        );
      }
    }
    
    Reviews.propTypes = {
      title: PropTypes.string,
      reviews: PropTypes.array,
      Lab: PropTypes.object,
      onReply: PropTypes.func,
      currentUser: PropTypes.object,
      ServiceID: PropTypes.string,
    };
    
    ;
    
    export default Reviews;
    
